import { Component, OnInit } from '@angular/core';
import { MainComponent } from '../main/main.component';
import { GenericTableComponent } from '../generic-components/generic-table/generic-table.component';
import { TableConfig } from '../generic-components/generic-table/class/TableConfig';
import { Incident } from '../models/Incident';
import { PageInformations } from '../generic-components/generic-table/class/PageInformations';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericSearchService } from '../generic-components/generic-search/generic-search.service';
import { PageEvent } from '@angular/material/paginator';
import { GenericCreateButtonComponent } from '../generic-components/generic-create-button/generic-create-button.component';
import { GenericSearchLabelComponent } from '../generic-components/generic-search-label/generic-search-label.component';
import { Dialog } from '@angular/cdk/dialog';
import { MatDialog } from '@angular/material/dialog';
import { IncidentDetailsComponent } from './incident-details/incident-details.component';
import { IncidentService } from './incident.service';
import { GenericValidateComponent } from '../generic-components/generic-validate/generic-validate.component';
import { ToastrService } from 'ngx-toastr';
import { GenericToastrService } from '../generic-components/generic-toastr/generic-toastr.service';

@Component({
  selector: 'app-incident',
  imports: [MainComponent, GenericTableComponent, GenericSearchLabelComponent],
  templateUrl: './incident.component.html',
  styleUrl: './incident.component.css',
})
export class IncidentComponent implements OnInit {
  listIncident: Incident[] = [];

  pageInformations: PageInformations = new PageInformations();

  emitClickRow = 'details';

  searchQuery: string = "";

  tableConfig: TableConfig = {
    columns: [
      {
        id: 'idIncident',
        libelle: 'ID',
        property: 'idIncident',
        researchable: false,
      },
      {
        id: 'dateIncident',
        libelle: "Date d'incident",
        property: 'dateIncident',
        type: 'date',
        researchable: true,
      },
      {
        id: 'client',
        libelle: 'Client',
        property: 'client',
        searchOn: 'comparison.correspondance.libelleDivalto',
        researchable: true,
      },
      {
        id: 'description',
        libelle: 'Description',
        property: 'description',
        researchable: false,
      },
      {
        id: 'type',
        libelle: "Type d'incident",
        property: 'type',
        searchOn: 'typeIncident.libelle',
        researchable: false,
      },

      {
        id: 'statut',
        libelle: "Statut d'incident",
        property: 'statut',
        searchOn: 'statutIncident.libelle',
        researchable: false,
      },
      {
        id: 'options',
        libelle: 'Options',
        property: 'options',
        researchable: false,
      },
    ],
  };

  constructor(
    private searchService: GenericSearchService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private incidentService: IncidentService,
    private toastr: GenericToastrService
  ) {}

  ngOnInit(): void {
    this.loadincidents();
  }
  pageEvent(event: PageEvent) {
    this.pageInformations.pageIndex = event.pageIndex;
    this.pageInformations.pageSize = event.pageSize;
    this.loadincidents();
  }

  search(query?:string){
    if(query){
      this.searchQuery = query;
      this.loadincidents();
    } else {
      this.searchQuery = "";
      this.loadincidents();
    }
  }

  loadincidents(): void {
    this.spinner.show();

    let query: string;

    if (this.searchQuery == "") {
      query =
        '(statutIncident.codeStatutIncident==EC);(typeIncident.codeTypeIncident!=CORRG;typeIncident.codeTypeIncident!=CORBIT)';
    } else {
      query =
        this.searchQuery + ';(statutIncident.codeStatutIncident==EC);(typeIncident.codeTypeIncident!=CORRG;typeIncident.codeTypeIncident!=CORBIT)';
    }
    this.searchService
      .search(
        'incident',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.size,
        'idIncident=asc'
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.listIncident = res.content;
          this.pageInformations = this.searchService.updatePageInformations(
            this.pageInformations,
            res
          );
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  openDetails(row: any) {
    const dialogRef = this.dialog.open(IncidentDetailsComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        incident: row,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.toastr.openSnackBarSuccess("L'incident a bien été affranchi !");
        this.loadincidents();
      }
    });
  }

  public createAffranchi(row: any) {
    const dialogRef = this.dialog.open(GenericValidateComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        libelle: 'Voulez-vous vraiment affranchir cet incident ?',
      },
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result === true) {
          this.incidentService.createAffranchi(row).subscribe((result) => {
            this.toastr.openSnackBarSuccess(
              "L'incident a bien été affranchi !"
            );
            this.loadincidents();
          });
        }
      },
      (error) => {
        this.toastr.openSnackBarProblem(error.message);
      }
    );
  }
}
